module.exports = __webpack_public_path__ + "static/media/4ODA13.d77c62f8.jpg";